import { html } from 'lit-html';
import { ItemJsEnv } from '../../models/item_js_env';
import { CarouselItems } from '../../../core/views/pc/carousel_item/carousel_items';

/**
 * おすすめ関連商品エリア
 * @param model 商品詳細画面情報
 */
// 商品詳細画面では、このエリアはサーバ側でレンダリングする。ここは非同期処理エリアのサンプルとして参考
export const RecommendRelatedItems = (model: ItemJsEnv) => html`
  <div class="o-colBox -margin24 o-recommendArea_head">
    <div class="a-colitem">
      <div class="o-colBox -margin24">
        <div class="a-heading -typeh3">
          <h2 class="a-heading_text">おすすめの関連商品</h2>
        </div>
      </div>
    </div>
  </div>
  ${CarouselItems(model.recommendRelatedItems, model.isLogin, "RelatedItems-carousel", undefined, "recom_DtRer")}
`;
